module.exports = __webpack_public_path__ + "static/media/ArunRaghupati@3x.7c6fa4e5.png";